import { createHocName } from '@wix/communities-forum-client-commons';

const withHocName = (name) => (Component) => {
  Component.displayName = createHocName(name, Component);
  return Component;
};

export default withHocName;
